import Player from "../Models/Player";
import { Global } from "../Shared/Global";
import NetworkLogic from "../Shared/NetworkLogic";
import UIManager from "../Shared/UIManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class PlayerBalanceUI extends cc.Component {    
    @property(cc.Label)
    lbMoney: cc.Label = null

    @property(cc.Node)
    nodeRefresh: cc.Node = null

    private _lowerScoreFinished = true
    
    onLoad () {
        cc.director.on(Global.UserEvent.UpdateMoney, this.pullMoney, this)
        cc.director.on(Global.UserEvent.PlayerPyChanged, this.onPlayerPyChanged, this)
        cc.director.on(Global.UserEvent.CloseThirdGame, this.onCloseThirdGame, this)
    }

    start () {
        this.refreshMoney()
    }

    onDestroy () {
        cc.director.off(Global.UserEvent.UpdateMoney, this.pullMoney, this)
        cc.director.off(Global.UserEvent.PlayerPyChanged, this.onPlayerPyChanged, this)
        cc.director.off(Global.UserEvent.CloseThirdGame, this.onCloseThirdGame, this)
    }

    onBtnClick (eventTouch, userData) {
        if (userData === "refresh" && Player.isLogedIn()) {
            this.pullMoney(0)
        }
    }

    pullMoney (flag) {
        this.nodeRefresh.runAction(cc.repeatForever(cc.sequence(cc.rotateBy(0.5, 360 * 2), cc.callFunc(function () {
            if (this._lowerScoreFinished) {
                this.nodeRefresh.stopAllActions()
            }
        }.bind(this)))))

        this._lowerScoreFinished = false
        UIManager.showLoadingUI()
        NetworkLogic.lowerScore(flag, function (data) {
            UIManager.hideLoadingUI()
            this._lowerScoreFinished = true
            Player.setPy("money", data)
        }.bind(this), function (response) {
            this._lowerScoreFinished = true
            response && UIManager.showToastUI("获取金币失败，请重新刷新金币！", Global.ToastType.Warnning)
        }.bind(this))
    }

    private onPlayerPyChanged (data) {
        if (data.property === "money") {
            this.refreshMoney()
        }
    }

    private refreshMoney () {
        this.lbMoney.string = Player.getPy("money")
    }

    private onCloseThirdGame () {
        this.pullMoney(1)
    }
}
